import * as React from 'react'
import {
  Stack,
  FieldLabel,
  FieldValue,
  TextInput,
  TextAreaInput,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { ServiceItem } from '../../../../../../models/sale.constants'
import { INPUT_MAX_CHAR, TEXT_AREA_MAX_CHAR } from '../../constants'

interface Props {
  itemDetailsInputs: ItemDetailsInputs | ServiceItem
  handleInputChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
}

interface ItemDetailsInputs {
  itemName: string
  serialNumber: string
  description: string
  initialCondition: string
}

export const ItemInputForm: React.FC<Props> = ({
  itemDetailsInputs,
  handleInputChange,
}) => {
  const t = useT()
  const copies = {
    itemName: t('Item name', { _context: 'Item name label' }),
    required: t('Required', {
      _context: 'Item name label required help text',
    }),
    enterItemName: t('Enter item name', {
      _context: 'Item name field placeholder',
    }),
    serialNumber: t('Serial number', { _context: 'Serial number label' }),
    enterSerialNumber: t('Enter serial number', {
      _context: 'Serial number field placeholder',
    }),
    description: t('Description', { _context: 'Item description label' }),
    descriptionHelp: t('Include make, model, color or any accessories', {
      _context: 'Item description label help text',
    }),
    enterDescription: t('Enter description', {
      _context: 'Description field placeholder',
    }),
    condition: t('Condition', { _context: 'Condition label' }),
    conditionHelp: t('Include any visible damage to the customer item', {
      _context: 'Condition label help text',
    }),
    enterCondition: t('Enter condition', {
      _context: 'Condition field placeholder',
    }),
  }

  return (
    <form data-testid="item-input-form">
      <Stack space={5} className="vd-pt5">
        <Stack space={0}>
          <FieldLabel
            label={copies.itemName}
            htmlFor="itemName"
            supplementaryLabel={copies.required}
          />
          <FieldValue>
            <TextInput
              autoComplete="off"
              placeholder={copies.enterItemName}
              id="itemName"
              name="itemName"
              value={itemDetailsInputs.itemName}
              required
              onChange={handleInputChange}
              maxLength={INPUT_MAX_CHAR}
            />
          </FieldValue>
        </Stack>
        <Stack space={0} style={{ width: '50%' }}>
          <FieldLabel label={copies.serialNumber} htmlFor="serialNumber" />
          <FieldValue>
            <TextInput
              autoComplete="off"
              placeholder={copies.enterSerialNumber}
              id="serialNumber"
              name="serialNumber"
              value={itemDetailsInputs.serialNumber}
              onChange={handleInputChange}
              maxLength={INPUT_MAX_CHAR}
            />
          </FieldValue>
        </Stack>
        <Stack space={0}>
          <FieldLabel
            label={copies.description}
            htmlFor="description"
            supplementaryLabel={copies.descriptionHelp}
          />
          <FieldValue>
            <TextAreaInput
              autoComplete="off"
              placeholder={copies.enterDescription}
              id="description"
              name="description"
              value={itemDetailsInputs.description}
              onChange={handleInputChange}
              maxLength={TEXT_AREA_MAX_CHAR}
            />
          </FieldValue>
        </Stack>
        <Stack space={0}>
          <FieldLabel
            label={copies.condition}
            htmlFor="initialCondition"
            supplementaryLabel={copies.conditionHelp}
          />
          <FieldValue>
            <TextAreaInput
              autoComplete="off"
              placeholder={copies.enterCondition}
              id="initialCondition"
              name="initialCondition"
              value={itemDetailsInputs.initialCondition}
              onChange={handleInputChange}
              maxLength={TEXT_AREA_MAX_CHAR}
            />
          </FieldValue>
        </Stack>
      </Stack>
    </form>
  )
}
